import React from 'react';
import {Link} from 'react-router-dom';

export default class PolicyFooter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className={`calc-footer-flex ${this.props.className ?? ''}`}>
                    <Link to="/" className="return-footer-button full-button">戻る</Link>
                </div>
            </React.Fragment>
        );
    }
}